import { readableOn } from '../../theme/contrast';
import { themeStyle } from '../../theme/applyTheme';
import type { Theme } from '../../theme/presets';

type SheetPreviewProps = {
  theme: Theme;
};

const SAMPLE = [
  { name: 'Rekenen', color: '#c9a24d' },
  { name: 'Taal', color: '#7aa2c9' },
  { name: 'Wereld', color: '#8fb98a' },
];

/** A small timetable in the theme being edited, so the sheet can be judged without leaving the panel. */
export function SheetPreview({ theme }: SheetPreviewProps) {
  return (
    <div aria-hidden="true" className="sheet sheet-own themed" style={themeStyle(theme)}>
      <div className="panel flex flex-col gap-2 p-4">
        <p className="text-3xl" style={{ fontFamily: 'var(--font-heading)', color: 'var(--accent)' }}>
          Week 12
        </p>
        <hr className="border-t" />
        <div className="flex gap-2">
          {SAMPLE.map(({ name, color }) => (
            <span key={name} className="flex-1 rounded-md px-2 py-1 text-sm font-semibold" style={{ background: color, color: readableOn(color) }}>
              {name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
